import React from 'react';
import QRCode from 'react-qr-code';
import { X } from 'lucide-react';
import './QRCodeModal.css';

const QRCodeModal = ({ isOpen, onClose, url, title = 'Scan QR Code' }) => {
    if (!isOpen) return null;

    const currentUrl = url || window.location.href;

    return (
        <div className="qr-modal-overlay" onClick={onClose}>
            <div className="qr-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="qr-modal-header">
                    <h3 className="qr-modal-title">{title}</h3>
                    <button className="qr-modal-close" onClick={onClose} aria-label="Close">
                        <X size={24} />
                    </button>
                </div>
                <div className="qr-modal-body">
                    <div className="qr-code-wrapper">
                        <div className="qr-code-container">
                            <QRCode
                                value={currentUrl}
                                size={256}
                                level="H"
                                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QRCodeModal;
